"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRetryLink = createRetryLink;

var _apolloLinkRetry = require("apollo-link-retry");

function createRetryLink({
  delay = 5000
} = {}) {
  return new _apolloLinkRetry.RetryLink({
    delay: {
      initial: delay,
      max: Infinity,
      jitter: true
    },
    attempts: {
      max: operation => operation.getContext().max,
      retryIf: (error, operation) => !!error && !operation.query.definitions.some(definition => definition.operation === 'mutation')
    }
  });
}